import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function Youtube({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" fillRule="evenodd" clipRule="evenodd" d="M19.8153 5.41816C20.6763 5.64864 21.353 6.32526 21.5835 7.18627H21.5818C22 8.7453 22 12 22 12C22 12 22 15.2547 21.5818 16.8137C21.3513 17.6747 20.6747 18.3514 19.8136 18.5818C18.2545 19 12 19 12 19C12 19 5.74547 19 4.18637 18.5818C3.32532 18.3514 2.64867 17.6747 2.41818 16.8137C2 15.2547 2 12 2 12C2 12 2 8.7453 2.41818 7.18627C2.64867 6.32526 3.32532 5.64864 4.18637 5.41816C5.74547 5 12 5 12 5C12 5 18.2545 5 19.8153 5.41816ZM15.1972 12L9.99964 9.00048V14.9995L15.1972 12Z" fill="currentColor" /></Svg>;
}
export default Youtube;